import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// each Vuex instance is just a single state tree.
const state = {
    currentTab: 'welcome-wrapper',
    intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: 0.5
    }
}

const mutations = {
    setCurrentTab(state, id) {
        state.currentTab = id;
    }
}

const actions = {
    setActiveTab ({ commit }, id) {
        commit('setCurrentTab', id);
    }
}

// getters are functions.
const getters = {
    currentTab: state => state.currentTab,
    intersectionOptions: state => state.intersectionOptions
}

export const store = new Vuex.Store({
    state,
    getters,
    actions,
    mutations
})